export default __webpack_public_path__ + "static/media/windows-icon-disable.2651f18a.svg";